import { Box, Image, Text } from '@chakra-ui/react';
import { Company } from '../types/company';
import { FC } from 'react';

interface Props {
  experience: Company;
}
export const ExperienceItem: FC<Props> = ({ experience }) => {
  return (
    <Box py={{ base: 2, md: 3 }} px={{ base: 2, md: 6 }}>
      <Box
        position="relative"
        border="1px solid"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius="2xl"
        p={{ base: 6, md: 8 }}
        overflow="hidden"
        _hover={{
          borderColor: 'rgba(66,153,225,0.6)',
          boxShadow: '0 0 40px rgba(66,153,225,0.15)',
          transform: 'translateY(-4px)',
        }}
        transition="all 0.3s ease"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          height="2px"
          bgGradient="linear(to-r, transparent, blue.400, transparent)"
          opacity={0.8}
        />
        <Box
          position="absolute"
          top="-40px"
          right="-40px"
          width="160px"
          height="160px"
          bg="radial-gradient(circle, rgba(66,153,225,0.25) 0%, rgba(66,153,225,0.08) 40%, transparent 70%)"
          filter="blur(40px)"
          pointerEvents="none"
        />
        <Box
          position="absolute"
          bottom="-50px"
          left="-50px"
          width="180px"
          height="180px"
          bg="radial-gradient(circle, rgba(66,153,225,0.18) 0%, rgba(66,153,225,0.06) 40%, transparent 70%)"
          filter="blur(50px)"
          pointerEvents="none"
        />
        <Box display="flex" gap={{ base: 2, md: 6 }} alignItems="flex-start">
          <Box mt={{ base: 3, md: 3 }}>
            <Image
              src={experience.icon}
              alt={experience.name}
              maxH={{ base: '40px', md: '60px' }}
              width={{ base: '70px', md: '100px' }}
              objectFit="contain"
            />
          </Box>
          <Box flex="1">
            <Box
              display="flex"
              flexWrap="wrap"
              alignItems="center"
              gap={{ base: 1, md: 4 }}
            >
              <Text
                fontSize={{ base: 'md', md: '2xl' }}
                fontWeight="bold"
                color="white"
              >
                {experience?.title}
              </Text>
              <Text fontSize={{ base: 'sm', md: 'md' }} color="gray.400">
                {experience?.startDate} - {experience?.endDate}
              </Text>
            </Box>
            <Text fontSize="md" color="blue.400" fontWeight="medium">
              {experience?.name}
            </Text>
            <Text
              mt={{ base: 2, md: 4 }}
              fontSize={{ base: 'sm', md: 'md' }}
              color="gray.300"
              lineHeight={{ base: '1.3', md: '1.4' }}
              maxW="800px"
            >
              {experience?.description}
            </Text>
            {experience?.achievements?.length ? (
              <Box mt={{ base: 2, md: 2 }}>
                {experience.achievements.map((item: string, index: number) => (
                  <Text
                    key={index}
                    fontSize={{ base: 'sm', md: 'md' }}
                    color="gray.400"
                    lineHeight="1.6"
                    mt={2}
                  >
                    • {item}
                  </Text>
                ))}
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
